export default {
    create_comment: false
}